// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ow-0";
export var buttonContainer = "_ow-3";
export var cancelButton = "_ow-4";
export var headerSection = "_ow-6";
export var headerTitle = "_ow-9";
export var messageSideLeft = "_ow-1";
export var messageSideRight = "_ow-2";
export var orderNumberContainer = "_ow-7";
export var orderNumberLabel = "_ow-8";
export var submitButton = "_ow-5";